import { VerifyAccountLayout } from './layout';
import { VerifyAccountForm } from './form';
import { PageMeta } from '../../components/PageMeta';

export const VerifyAccount = () => {
    return (
        <>
            <PageMeta
                title="Verify email · Dodil Cloud"
                description="Enter the verification code we sent to your email."
            />
            <VerifyAccountLayout>
                <VerifyAccountForm />
            </VerifyAccountLayout>
        </>
    );
};
